module.exports = __webpack_public_path__ + "img/top@2x.0c86d1bd.png";